import React, { useEffect, useState, useLayoutEffect } from "react";
import { Route, withRouter } from "react-router";
import Loader from "../../Container/Loader";
import Pen from "../../Assets/pen.svg";
import Send from "../../Assets/send.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import FullSidebarAdmin from "../../Container/FullPageSidebar/admin";
import Modal from "../../Container/Modal";

// -- redux
import { connect } from "react-redux";
import { GetAdmins, UpdateAdminsStatus, DeleteAdmin, ResetPasswordAdmin } from "../../Redux/Actions/AdminAction";

function Admin(props) {
  const [OpenModal, setModal] = useState(false);
  const [Title, setTitle] = useState(false);
  const [Id, setId] = useState(false);
  const [InitialArray, setInitialArray] = useState([]);
  const [CardsArray, setCardsArray] = useState([]);

  const showAMPM = (time) => {
    let AMPM = "";
    let hourStr = "";
    let minStr = "";
    if (time) {
      let hours = parseInt(time.split(":")[0], 10);
      let minutes = parseInt(time.split(":")[1], 10);
      if (hours > 11) {
        if (hours > 12) hours = hours - 12;
        AMPM = "PM";
      } else {
        AMPM = "AM";
        if (hours === 0) hours = 12;
      }
      if (hours < 10) {
        hourStr = "0" + String(hours);
      } else {
        hourStr = String(hours);
      }
      if (minutes < 10) {
        minStr = "0" + String(minutes);
      } else {
        minStr = String(minutes);
      }
      return hourStr + " : " + minStr + " " + AMPM;
    } else {
      return time;
    }
  };

  const permissionsString = (items) => {
    let count = 0;
    let str = "";
    items.map((item) => {
      if (item.status === 1) {
        if (count === 0) {
          str = str + item.title;
        } else {
          str = str + ", " + item.title;
        }
        count = count + 1;
      }
    });
    return str;
  };

  const dateFormatter = (dateStr) => {
    if (dateStr) {
      let dd = dateStr.split("-")[2];
      let mm = dateStr.split("-")[1];
      let yy = dateStr.split("-")[0];
      return `${mm}/${dd}/${yy}`;
    } else {
      return "";
    }
  };

  useEffect(() => {
    const data = {
      status: "",
    };
    props.GetAdmins(data);
  }, [props.update_data, props.delete_data, props.add_data, props.edit_data]);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      props.enabled(props.data.data.enabled);
      props.disabled(props.data.data.disabled);
      props.clear("clear");
      setTimeout(function () {
        props.clear("");
      }, 1000);
      setInitialArray(props.data.data.data);
      CardsArray.map((items) => {
        let modules = items.user_permissions.map(function (item) {
          return item.title;
        });
        items.permissions_str = modules.join(", ");
      });
    }
  }, [props.data, props.update_data, props.delete_data, props.add_data, props.edit_data]);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      setCardsArray(InitialArray);
    }
  }, [props.update_data, props.add_data, props.edit_data, InitialArray]);

  const deleteAdmin = (e, type, id) => {
    e.preventDefault();
    setModal(type);
    setId(id);
  };

  const handleModal = (e, type, title, id) => {
    e.preventDefault();
    setModal(type);
    setTitle(title);
    setId(id);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    let data;
    if (type === "enable_yes") {
      data = {
        id: Id,
        status: 0,
      };
      props.UpdateAdminsStatus(data);
    } else {
      setModal(!OpenModal);
    }

    if (type === "disable_yes") {
      data = {
        id: Id,
        status: 1,
      };
      props.UpdateAdminsStatus(data);
    } else {
      setModal(!OpenModal);
    }

    if (type === "delete_yes") {
      props.DeleteAdmin(Id);
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  useEffect(() => {
    if (!props.Search) {
      setCardsArray(InitialArray);
    }
    if (props.Search.length > 2) {
      const FilteredArray = InitialArray.filter((post) => {
        const postName = post.full_name;
        return postName.toLowerCase().includes(props.Search.toLowerCase());
      });
      setCardsArray(FilteredArray);
    }
  }, [props.Search]);

  const changePage = (items) => {
    props.history.push({
      pathname: "admin/edit-admin",
      state: items,
    });
  };

  const handleSend = (id) => {
    props.ResetPasswordAdmin(id);
  };

  useLayoutEffect(() => {
    setTimeout(() => {
      if (props.location.method && props.location.method === "add" && props.add_data) {
        props.respType({ type: "Admin", method: props.location.method, response: props.add_data });
      }
    }, 1500);
  }, [props.add_data]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (props.location.method && props.location.method === "update" && props.edit_data) {
        props.respType({ type: "Admin", method: props.location.method, response: props.edit_data });
      }
    }, 1500);
  }, [props.edit_data]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (props.location.method && props.location.method === "delete" && props.delete_data) {
        props.respType({ type: "Admin", method: props.location.method, response: props.delete_data });
      }
    }, 1500);
  }, [props.delete_data]);

  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-2">
        <Route exact path={["/dashboard/admin/add-admin", "/dashboard/admin/edit-admin"]} component={FullSidebarAdmin} />
        <div className="module-table-wrap w-100 table-responsive">
          <div className="table-wrap">
            <table className="table table-bordered m-0">
              <thead className="text-grey-6">
                <tr>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Full Name</span>
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Type</span>
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Email Address</span>
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Permissions</span>
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Last Login</span>
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Reset Password Link</span>
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <span className="f-16">Status</span>
                  </th>
                  <th scope="col" className="dark-background">
                    <span className="f-16">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody className="light-grey-background">
                {CardsArray.length > 0 ? (
                  CardsArray.map((items, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <span className="text-white pl-2 pr-2">{items.full_name}</span>
                        </td>
                        <td>
                          <span className="text-white pl-2 pr-2">{items.role_id === 1 ? "Super Admin" : "Admin"}</span>
                        </td>
                        <td>
                          <span className="text-white pl-2 pr-2">{items.email}</span>
                        </td>
                        <td className="pl-2 pr-2" style={{ whiteSpace: "pre-line" }}>
                          <span style={{ width: "340px", display: "block" }} className="text-white">
                            {permissionsString(items.user_permissions)}
                          </span>
                        </td>
                        <td>
                          {items.loggedin_at && <p className="text-white pl-2 pr-2 mb-0">{dateFormatter(items.loggedin_at.split(" ")[0])}</p>}
                          {items.loggedin_at && <p className="text-white pl-2 pr-2 mb-0">{showAMPM(items.loggedin_at.split(" ")[1])}</p>}
                          {items.loggedin_at && <p className="text-white pl-2 pr-2 mb-0">{items.loggedin_at.split(" ")[2]}</p>}
                        </td>
                        <td onClick={() => handleSend(items.id)} className="d-flex align-items-center cursor-pointer">
                          <span className="text-green pl-2 pr-3">Send Now </span>
                          <img src={Send} alt="send" />
                        </td>
                        <td className="text-center pl-4 pr-4">
                          <label className="switch mb-0">
                            <input type="checkbox" checked={items.user_status === 1} readOnly onClick={(e) => handleModal(e, items.user_status === 1 ? "enable" : "disable", items.full_name, items.id)} />
                            <span className="slider round" />
                          </label>
                        </td>
                        <td>
                          <div className="d-flex">
                            <img onClick={() => changePage(items)} src={Pen} alt="pen" className="ml-2 mr-2 cursor-pointer" />
                            <img onClick={(e) => deleteAdmin(e, "delete", items.id)} src={DeleteIcon} alt="Delete" className="ml-2 mr-3 cursor-pointer" />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center border-0">
                      <p className="m-0 text-white">Nothing found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {OpenModal && <Modal Name={Title} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
      </div>
    </>
  );
}

const mapStateToProps = ({ AdminReducer }) => {
  const { loading, table_loading, data, update_data, delete_data, add_data, reset_data, edit_data } = AdminReducer;
  return { loading, table_loading, data, update_data, delete_data, add_data, reset_data, edit_data };
};

const mapDispatchToProps = {
  GetAdmins,
  UpdateAdminsStatus,
  DeleteAdmin,
  ResetPasswordAdmin,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admin));
